import {useCallback, useState} from 'react';
import cx from 'classnames';
import {useCachedMedia} from '~/common/hooks/useCachedMedia';
import {STICKER_UPLOAD_INDEXED_DB_STORE_NAME} from '~/common/indexed-db/dexieStores';
import {StickerUpload} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Sticker/components/StickerUpload/StickerUpload';
import {StickerList} from './StickerList';
import {useStickers} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Sticker/components/Stickers/actions/useStickers';
import {useStickerCanvasAdder} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Sticker/components/Stickers/actions/useStickerCanvasAdder';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import './Stickers.sass';

export const Stickers = ({flipEnvelope}) => {
  const [showAllStickers, setShowAllStickers] = useState(false);
  const [isCustom, setIsCustom] = useState(false);
  const [activeId, setActiveId] = useState('');

  const {cachedMediaList} = useCachedMedia(STICKER_UPLOAD_INDEXED_DB_STORE_NAME);
  const hasMedia = cachedMediaList?.length > 0;
  const {stickerIcons, customStickerMedias, stickerMediasMapping, customStickerMediasMapping} =
    useStickers();
  const isDesktop = useIsLargishAndUp();
  useStickerCanvasAdder({
    stickerMediasMapping,
    customStickerMediasMapping,
    isCustom,
    setActiveId,
    activeId,
    isDesktop,
  });

  const onClickGenericHandler = useCallback(
    (id, isCustomSticker) => {
      setIsCustom(isCustomSticker);
      flipEnvelope(true);
      setActiveId(id);
    },
    [setIsCustom, flipEnvelope, setActiveId]
  );
  const onClickStickerHandler = useCallback(
    (icon, id) => {
      onClickGenericHandler(id, false);
    },
    [onClickGenericHandler]
  );
  const onClickCustomStickerHandler = useCallback(
    (icon, id) => {
      onClickGenericHandler(id, true);
    },
    [onClickGenericHandler]
  );

  const toggleShowAllCustomStickers = useCallback(() => {
    setShowAllStickers((prev) => !prev);
  }, [setShowAllStickers]);

  return (
    <div className={cx('editor-icons', 'editor-icons__sticker')}>
      <div
        className={cx('sticker-upload-container', {
          'sticker-upload-container--filled': hasMedia,
          'sticker-upload-container--show-less': hasMedia && !showAllStickers,
        })}
      >
        <StickerUpload onClickHandler={onClickCustomStickerHandler} />

        <StickerList
          flipEnvelope={flipEnvelope}
          showAll={showAllStickers}
          isCustom
          stickerIcons={customStickerMedias}
          stickerMediasMapping={customStickerMediasMapping}
          toggleShowAll={toggleShowAllCustomStickers}
          onClickHandler={onClickCustomStickerHandler}
        />
      </div>

      <StickerList
        flipEnvelope={flipEnvelope}
        showAll={showAllStickers}
        stickerIcons={stickerIcons}
        stickerMediasMapping={stickerMediasMapping}
        onClickHandler={onClickStickerHandler}
      />
    </div>
  );
};
